/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_3_B1Inputs */

const en_mk_agent_3_b1 = /** @type {(inputs: Mk_Agent_3_B1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One channel per division, plus threads and direct messages`)
};

const id_mk_agent_3_b1 = /** @type {(inputs: Mk_Agent_3_B1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu channel per divisi, plus thread dan pesan langsung`)
};

/**
* | output |
* | --- |
* | "One channel per division, plus threads and direct messages" |
*
* @param {Mk_Agent_3_B1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_3_b1 = /** @type {((inputs?: Mk_Agent_3_B1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_3_B1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_3_b1(inputs)
	return en_mk_agent_3_b1(inputs)
});